import api from './api';
import { Purchase, PurchaseValidation, CreatePurchaseData, ApiResponse, PaginatedResponse } from '../types';

export const purchaseService = {
  async getAll(page = 1, filters?: any): Promise<PaginatedResponse<Purchase>> {
    const response = await api.get<PaginatedResponse<Purchase>>('/purchases', {
      params: { page, ...filters }
    });
    return response.data;
  },

  async getById(id: number): Promise<Purchase> {
    const response = await api.get<Purchase>(`/purchases/${id}`);
    return response.data;
  },

  async validatePurchase(associadoId: number, parceiroId: number): Promise<PurchaseValidation> {
    const response = await api.post<PurchaseValidation>('/purchases/validate', {
      associado_id: associadoId,
      parceiro_id: parceiroId
    });
    return response.data;
  },

  async create(data: CreatePurchaseData): Promise<ApiResponse<Purchase>> {
    const response = await api.post<ApiResponse<Purchase>>('/purchases', data);
    return response.data;
  },

  async confirm(id: number, valorFinal?: number): Promise<ApiResponse<Purchase>> {
    const response = await api.patch<ApiResponse<Purchase>>(`/purchases/${id}/confirm`, {
      valor_final: valorFinal
    });
    return response.data;
  },

  async cancel(id: number, motivo?: string): Promise<ApiResponse<Purchase>> {
    const response = await api.patch<ApiResponse<Purchase>>(`/purchases/${id}/cancel`, {
      motivo
    });
    return response.data;
  },

  async getByAssociate(associadoId: number, page = 1): Promise<PaginatedResponse<Purchase>> {
    const response = await api.get<PaginatedResponse<Purchase>>(`/associates/${associadoId}/purchases`, {
      params: { page }
    });
    return response.data;
  },

  async getByPartner(parceiroId: number, page = 1): Promise<PaginatedResponse<Purchase>> {
    const response = await api.get<PaginatedResponse<Purchase>>(`/partners/${parceiroId}/purchases`, {
      params: { page }
    });
    return response.data;
  }
};
